import React, { useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import SmartForm from 'components/SmartForm';
import { getSetting } from 'rdx/config';
import { getVatRates, saveVatRate } from 'rdx/vatRates';
import { CustomTable, CTAButtons } from 'components';

import * as schemas from './shapes';

import './generalDetails.scss';

function GeneralDetails() {
  const [configState, setConfigState] = useState({});
  const configRef = useRef(null);
  const taxRef = useRef(null);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const vatRates = useSelector(getVatRates).reverse();

  const country = useSelector(getSetting('country'));
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const default_language = useSelector(getSetting('default_language'));

  const timezone = useSelector(getSetting('timezone'));
  const dateformat = useSelector(getSetting('dateformat'));
  const numberformat = useSelector(getSetting('numberformat'));
  const currency = useSelector(getSetting('currency'));

  useEffect(() => {
    setConfigState({
      country,
      default_language,
      timezone,
      dateformat,
      numberformat,
      currency,
    });
  }, [country, default_language, timezone, dateformat, numberformat, currency]);

  const handleConfigSubmit = () => {
    //  handle config submit
    // api saveConfParameter (parameterName, parameterValue)
  };

  const handleTaxSubmit = (values) => dispatch(saveVatRate(values));
  // handle new tax rate submit
  // api saveVatRate (name - required)

  const onClose = () => {
    // do some clean up with form changes and go back
    navigate('/setup/personal');
  };

  const onNext = () => {
    // do some clean up with form changes and go to next page
    navigate('/setup/company');
  };

  const options = {
    country: ['Bulgaria', 'Estonia'],
  };

  const buttons = {
    close: {
      onClick: onClose,
    },
    next: {
      onClick: onNext,
    },
  };

  return (
    <div className="flex-fill">
      <SmartForm
        ref={configRef}
        fields={schemas.general}
        state={configState}
        options={options}
        handleSubmit={handleConfigSubmit}
        className="general-details-page"
      />
      <h2 className="tax-rates-subtitle">Local tax rates</h2>
      <CustomTable
        bordered
        striped
        columns={schemas.taxTableFields}
        data={vatRates}
      />
      <h4 className="tax-rates-subtitle mt-3">Add new</h4>
      <SmartForm
        ref={taxRef}
        fields={schemas.taxRateForm}
        handleSubmit={handleTaxSubmit}
        className="tax-form"
      >
        <div className="w-100 d-flex justify-content-end">
          <Button size="sm" onClick={() => taxRef.current.submitForm()}>
            ADD TAX RATE
          </Button>
        </div>
      </SmartForm>
      <CTAButtons buttons={buttons} />
    </div>
  );
}

export default GeneralDetails;
